import { createRouterSelector } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const LIST_VIEW_ROUTES: string[] = [
	'software-list',
	'classic-business-list',
	'software-list-classic',
	'legacy-gin',
	'global-issue-navigator',
	'issue-navigator',
];

const LIST_VIEW_ROUTES_NEW: string[] = [
	'software-list',
	'classic-business-list',
	'software-list-classic',
	'legacy-gin',
	'global-issue-navigator',
	'issue-navigator',
	'issue-navigator-core',
	'issue-navigator-classic',
	'software-issue-navigator',
	'servicedesk-issues',
	'jsm-list-nin',
	'jwm-list-nin',
];

/**
 * Until we have added the option to open preview panel in list view, we will close the preview panels, without deselecting the issue in list view.
 */
// oxlint-disable-next-line typescript/no-invalid-void-type
export const useIsNotListViewRoute: (args_0: void) => boolean = createRouterSelector<boolean>(
	({ route }) => {
		if (fg('nin_add_list_routes_to_preview_panels_provider')) {
			return route?.name ? !LIST_VIEW_ROUTES_NEW.includes(route.name) : true;
		}
		return route?.name ? !LIST_VIEW_ROUTES.includes(route.name) : true;
	},
);
